import { render, staticRenderFns } from "./SongList.vue?vue&type=template&id=55fdd68f&scoped=true&"
import script from "./SongList.vue?vue&type=script&lang=js&"
export * from "./SongList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fdd68f",
  null
  
)

export default component.exports